import React, { memo } from 'react';

// import ChatPanel from '../../shared-components/chatPanel/ChatPanel';
import LastActionsPanel from '../../shared-components/lastActionsPanel/LastActionsPanel';
import NotificationPanel from '../../shared-components/notificationPanel/NotificationPanel';
import QuickNotesPanel from '../../shared-components/quickNotesPanel/QuickNotesPanel';

function RightSideLayout3() {
	return (
		<>
			{/* <ChatPanel /> */}

			<LastActionsPanel />

			<QuickNotesPanel />

			<NotificationPanel />
		</>
	);
}

export default memo(RightSideLayout3);
